import { Stack } from "@mui/material";
import { H4Component, NoticeList } from "./";
import {
  AlertInCircleIcon,
  BgBottomSquareIcon,
  BgTopSquareIcon,
} from "../../../images";

export const NotRightBlock = () => {
  return (
    <Stack
      sx={{
        backgroundColor: "#EAF1F6",
        borderTopLeftRadius: "12px",
        borderBottomRightRadius: "12px",
        padding: "28px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Stack
        style={{
          position: "absolute",
          top: "0",
          right: "20%",
          flexDirection: "row",
          gap: "4px",
        }}
      >
        <BgTopSquareIcon />
        <BgTopSquareIcon />
      </Stack>
      <BgBottomSquareIcon
        style={{
          position: "absolute",
          bottom: "0",
          right: "0",
        }}
      />

      <Stack gap="20px">
        <Stack gap="12px" flexDirection="row" alignItems="center">
          <H4Component
            text={"If Objection / Timing Not Right"}
            color={"#005EAB"}
          />
          <AlertInCircleIcon color={"#FE8836"} />
        </Stack>
        <NoticeList
          borderColor={"#9CBFDC"}
          text={[
            "“That’s totally fair — would it be helpful if I sent you a short case study or comparison" +
              " guide in the meantime? I can follow up closer to your next architecture review cycle.”",
          ]}
        />
      </Stack>
    </Stack>
  );
};
